<template>
  <label class="base-field">
    <span v-if="label" class="base-field__label">{{ label }}</span>
    <span v-if="hint" class="base-field__hint">{{ hint }}</span>

    <textarea
      v-if="type === 'textarea'"
      :value="modelValue"
      class="base-field__control base-field__control--textarea"
      :placeholder="placeholder"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>

    <select
      v-else-if="type === 'select'"
      :value="modelValue"
      class="base-field__control"
      v-bind="$attrs"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <slot />
    </select>

    <span v-else class="base-field__input-wrap" :class="{ 'has-toggle': isPassword }">
      <input
        :value="modelValue"
        :type="inputType"
        class="base-field__control"
        :placeholder="placeholder"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event.target.value)"
      />

      <button
        v-if="isPassword"
        type="button"
        class="base-field__toggle"
        :aria-label="passwordVisible ? 'Скрыть пароль' : 'Показать пароль'"
        @click.prevent="passwordVisible = !passwordVisible"
      >
        <svg v-if="!passwordVisible" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M2.2 12s3.7-6 9.8-6 9.8 6 9.8 6-3.7 6-9.8 6-9.8-6-9.8-6Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg v-else viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 3l18 18" />
          <path d="M10.7 5.2A10.8 10.8 0 0 1 12 5c6.1 0 9.8 7 9.8 7a17.6 17.6 0 0 1-3.1 3.8" />
          <path d="M6.5 6.6C3.7 8.2 2.2 12 2.2 12s3.7 7 9.8 7c1.7 0 3.2-.4 4.4-1" />
          <path d="M9.9 9.9A3 3 0 0 0 14.1 14" />
        </svg>
      </button>
    </span>
  </label>
</template>

<script>
export default {
  name: 'BaseInput',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      passwordVisible: false,
    };
  },
  computed: {
    isPassword() {
      return this.type === 'password';
    },
    inputType() {
      if (!this.isPassword) return this.type;
      return this.passwordVisible ? 'text' : 'password';
    },
  },
};
</script>

<style scoped>
.base-field {
  display: block;
}

.base-field__label {
  display: block;
  margin-bottom: 10px;
  font-weight: 700;
  color: var(--text);
}

.base-field__hint {
  display: block;
  margin: -4px 0 10px;
  color: var(--text-faded);
  font-size: 13px;
}

.base-field__input-wrap {
  position: relative;
  display: block;
}

.base-field__input-wrap.has-toggle .base-field__control {
  padding-right: 54px;
}

.base-field__control {
  width: 100%;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
  padding: 16px 18px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.base-field__control:focus {
  border-color: rgb(156 92 255 / 40%);
  box-shadow: 0 0 0 4px rgb(156 92 255 / 14%);
  background: rgba(255, 255, 255, 0.06);
}

.base-field__control::placeholder {
  color: var(--text-faded);
}

.base-field__toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  width: 42px;
  height: 42px;
  transform: translateY(-50%);
  border: 0;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--text-soft);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
}

.base-field__toggle:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text);
}

.base-field__toggle svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.base-field__control--textarea {
  min-height: 140px;
  resize: vertical;
}

select.base-field__control {
  appearance: none;
}
</style>
